import { ComponentPropDefinitionUtil, ComponentPropDefinitions } from "../../base/ComponentProps";
import { PanelPropDefinitions, PanelProps } from "../panel/PanelProps";
import { PropType } from "../../base/PropType";

export interface SearchPanelProps extends PanelProps {
    title: string;
}

export class SearchPanelPropDefinitions {
    private static searchPanelPropDefs: ComponentPropDefinitions;

    public static getDefinitions(): ComponentPropDefinitions {
        if (this.searchPanelPropDefs == null) {
            this.searchPanelPropDefs = {
                ...PanelPropDefinitions.cloneDefs(),
                ...this.buildSimpleProps()
            };
            ComponentPropDefinitionUtil.populateComponentPropNames(this.searchPanelPropDefs);
        }
        return this.searchPanelPropDefs;
    }

    private static buildSimpleProps(): ComponentPropDefinitions {
            return {
                title: {
                    type: PropType.string,
                    visibleInMcLeodTailor: true,
                    description: "Specifies the title that will be displayed at the top of the search panel."
                }
            }
        }
}
